<template>
  <div v-loading="showLoading" class="userInfo">
    <el-row :gutter="10">
      <el-col :span="6" class="firstCard">
        <el-card>
          <el-menu :default-active="activeName" @select="(index)=>{activeName=index}">
            <el-submenu index="1">
              <template slot="title">功能API</template>
              <el-menu-item v-for="item in checkApiList" :index="item.name">{{ item.name }}</el-menu-item>
            </el-submenu>
          </el-menu>
          <el-menu :default-active="activeName" @select="(index)=>{activeName=index}">
            <el-submenu index="2">
              <template slot="title">监控API</template>
              <el-submenu class="erji_submenu" index="2-1">
                <template slot="title">增改监控任务</template>
                <el-menu-item index="监控任务列表">监控任务列表</el-menu-item>
                <el-menu-item index="监控分组列表">监控分组列表</el-menu-item>
                <el-menu-item index="添加任务">添加任务</el-menu-item>
                <el-menu-item index="修改任务">修改任务</el-menu-item>
                <el-menu-item index="获取检测API接口">获取检测API接口</el-menu-item>
              </el-submenu>
              <el-submenu class="erji_submenu" index="2-2">
                <template slot="title">启用任务</template>
                <el-menu-item index="启用全部">启用全部</el-menu-item>
                <el-menu-item index="启动选中">启动选中</el-menu-item>
                <el-menu-item index="启动正常">启动正常</el-menu-item>
                <el-menu-item index="启动异常">启动异常</el-menu-item>
                <el-menu-item index="启动未知">启动未知</el-menu-item>
              </el-submenu>
              <el-submenu class="erji_submenu" index="2-3">
                <template slot="title">开启/关闭自动停用</template>
                <el-menu-item index="开启自动停用">开启自动停用</el-menu-item>
                <el-menu-item index="关闭自动停用">关闭自动停用</el-menu-item>
              </el-submenu>
              <el-submenu class="erji_submenu" index="2-4">
                <template slot="title">删除任务</template>
                <el-menu-item index="删除全部任务">删除全部任务</el-menu-item>
                <el-menu-item index="删除选中任务">删除选中任务</el-menu-item>
                <el-menu-item index="删除正常任务">删除正常任务</el-menu-item>
                <el-menu-item index="删除异常任务">删除异常任务</el-menu-item>
                <el-menu-item index="删除启用任务">删除启用任务</el-menu-item>
                <el-menu-item index="删除停用任务">删除停用任务</el-menu-item>
                <el-menu-item index="删除未知任务">删除未知任务</el-menu-item>
                <el-menu-item index="删除过期任务">删除过期任务</el-menu-item>
              </el-submenu>
              <el-submenu class="erji_submenu" index="2-5">
                <template slot="title">停用任务</template>
                <el-menu-item index="停用全部">停用全部</el-menu-item>
                <el-menu-item index="停用选中">停用选中</el-menu-item>
                <el-menu-item index="停用正常">停用正常</el-menu-item>
                <el-menu-item index="停用异常">停用异常</el-menu-item>
                <el-menu-item index="停用未知">停用未知</el-menu-item>
              </el-submenu>

              <el-submenu class="erji_submenu" index="2-6">
                <template slot="title">导出任务</template>
                <el-menu-item index="Excel导出">Excel导出</el-menu-item>
              </el-submenu>
            </el-submenu>
          </el-menu>
          <el-menu :default-active="activeName" @select="(index)=>{activeName=index}">
            <el-submenu index="3">
              <template slot="title">用户API</template>
              <el-menu-item index="获取用户数据">获取用户数据</el-menu-item>
            </el-submenu>
          </el-menu>
        </el-card>
      </el-col>
      <el-col :span="18" v-if="!apiData[activeName]">
        <div class="right">
          <el-card style="padding: 15px;height: 100%">
            <div style="text-align: center">
              <svg t="1660632759003" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2389" width="200" height="200"><path d="M512.736 992a483.648 483.648 0 0 1-164.672-28.8 36.88 36.88 0 1 1 25.104-69.36 407.456 407.456 0 1 0-184.608-136.512A36.912 36.912 0 0 1 129.488 801.6a473.424 473.424 0 0 1-97.472-290A480 480 0 1 1 512.736 992z" p-id="2390" fill="#1296db"></path><path d="M685.6 638.592a32 32 0 0 1-14.032-2.96l-178.048-73.888a36.8 36.8 0 0 1-22.912-34.016V236.672a36.944 36.944 0 1 1 73.888 0v266.72l155.2 64.272a36.336 36.336 0 0 1 19.952 48 37.616 37.616 0 0 1-34.048 22.928z" p-id="2391" fill="#1296db"></path></svg>
              <p style="color: #666666">该接口正在测试开发，请耐心等待</p>
            </div>
          </el-card>
        </div>
      </el-col>
      <!-- API右侧盒子-->
      <el-col :span="18" v-else>
        <div class="right">
          <el-card style="padding: 15px">
            <div class="header">
              <strong style="color: #555">接口地址: </strong>
              <span style="color: #777">{{ baseUrl }}{{ apiData[activeName].apiUrl }}</span>
            </div>
            <div class="header">
              <strong style="color: #555">请求方式: </strong>
              <span style="color: #777">GET/POST</span>
            </div>
            <div class="header">
              <strong style="color: #555">请求示例: </strong>
              <span style="color: #777;overflow-wrap: break-word;">{{ baseUrl }}{{ apiData[activeName].apiUrl }}?{{apiData[activeName].params.map(keyValue=>keyValue.name + '=' + keyValue.default).join('&')}}</span>
            </div>
            <!--请求参数说明-->
            <div class="table">
              <p style="border-left: 4px solid #00BDFF;">
                <span style="color: #555;display: inline-block;padding-left: 8px;">请求参数说明:</span>
              </p>
              <el-table :data="apiData[activeName].params" border style="width: 100%">
                <el-table-column label="名称" prop="name" width="150">
                </el-table-column>
                <el-table-column label="必填" prop="required" width="120">
                </el-table-column>
                <el-table-column label="类型" prop="type" width="120">
                </el-table-column>
                <el-table-column label="说明" prop="text">
                </el-table-column>
              </el-table>
            </div>
            <div v-if="apiData[activeName].hasNode" class="table">
              <p style="border-left: 4px solid #00BDFF;">
                <span style="color: #555;display: inline-block;padding-left: 8px;">可选节点:</span>
              </p>
              <el-table :data="nodeList" border style="width: 100%">
                <el-table-column label="名称" prop="name">
                </el-table-column>
                <el-table-column label="node参数值" prop="jiedianid">
                </el-table-column>
                <el-table-column label="类型">
                  <tempalte>String</tempalte>
                </el-table-column>
              </el-table>
            </div>
            <!-- 返回参数说明-->
            <div class="table">
              <p style="border-left: 4px solid #00BDFF;">
                <span style="color: #555;display: inline-block;padding-left: 8px;">返回参数说明:</span>
              </p>
              <el-table :data="apiData[activeName].resultKey" border style="width: 100%">
                <el-table-column label="名称" prop="name" width="200">
                </el-table-column>
                <el-table-column label="类型" prop="type" width="300">
                </el-table-column>
                <el-table-column label="说明" prop="text">
                  <template slot-scope="{row}">
                    <div v-html="row.text"></div>
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <!-- Json返回实例-->
            <div class="table">
              <p style="border-left: 4px solid #00BDFF;">
                <span style="color: #555;display: inline-block;padding-left: 8px;">JSON返回实例:</span>
              </p>

              <div class="json">
                <pre>{{ JSON.stringify(apiData[activeName].resultJson,null,2) }}</pre>
              </div>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import checkApiData from "./checkApiData";
import monitorApiData from "./monitorApiData";
import userApi from "./userApi";
export default {
  data() {
    return {
      baseUrl: 'https://api.new.urlzt.com/api/',
      apiData:{
        ...checkApiData,
        ...monitorApiData,
        ...userApi
      },
      showLoading: true,
      activeName: 'QQ域名检测',
      checkApiList: [], // api列表
      // 节点列表
      nodeList: [],
    }
  },
  created() {
    this.getApi()
    this.getNode()
  },
  methods: {
    async getApi() {
      try {
        const {data} = await this.$http.post('/apiinterface/apilist')
        if (data.status == 'success') {
          this.showLoading = false
          this.checkApiList = data.data
          this.current = data.data[0].interface_name
        } else {
          this.showLoading = false
          this.$message.error(data.msg)
        }
      } catch (err) {
        this.showLoading = false
        this.$message.error('网络异常,请稍后重试')
      }
    },
    async getNode() {
      try {
        const {data} = await this.$http.post('/apiinterface/nodelist')
        if (data.status == 'success') {
          this.nodeList = data.data
        } else {
          this.$message.error(data.msg)
        }
      } catch (err) {
        this.$message.error('网络异常,请稍后重试')
      }
    }
  }
}
</script>

<style lang="less" scoped>
.erji_submenu {
  /deep/ .el-submenu__title {
    background-color: #f8f8f8 !important;
  }
}

.userInfo {
  font-size: 14px;
  margin-top: 10px;

  /deep/ .el-menu.el-menu--inline {
    max-height: 550px;
    overflow-y: auto;
  }

  /deep/ .el-submenu__title {
    background-color: #eee;
  }

  /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/

  /deep/ .el-menu.el-menu--inline::-webkit-scrollbar {
    width: 5px;
    height: 5px;
    background-color: transparent;
  }

  /*定义滚动条轨道 内阴影+圆角*/

  /deep/ .el-menu.el-menu--inline::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    background-color: transparent;
  }

  /*定义滑块 内阴影+圆角*/

  /deep/ .el-menu.el-menu--inline::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: #0099ff;
  }

  /deep/ .el-card__header {
    padding: 10px 10px !important;
  }

  /deep/ .el-collapse {
    border-top: unset !important;
    border-bottom: unset !important;
  }

  ///deep/ .el-collapse-item__header.is-active {
  //  background-color: #f0f6ff !important;
  //}
  .active {
    background-color: #f0f6ff !important;
    color: #2d8cf0 !important;
  }

  /deep/ .el-collapse-item__header {
    padding: 0 10px;
  }

  .text {
    font-size: 14px;
  }

  .item {
    //margin: 4px 0;
    //padding: 5px 20px;
  }

  .firstCard {
    /deep/ .el-card__body {
      padding: unset;
    }
  }
}

.right {
  /deep/ .el-card__header {
    padding: 0 20px !important;
  }

  /deep/ .el-form-item__content {
    margin-left: 50px !important;
  }

  .header {
    margin-bottom: 10px;
  }
}

.second {
  padding-left: 20px;
}

.json {
  border: 1px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
}

//.active {
//  background-color: #f0f6ff;
//  color: #2d8cf0;
//}

.bigBox {
  padding: 0 16px;
  font-size: 14px;
  display: flex;
  align-items: center;

  .centerMain {
    .tip {
      margin: 0 0 8px 0;
      display: flex;
      align-items: center;

      /deep/ .el-avatar {
        width: 24px;
        height: 24px;
      }
    }
  }
}

.weixin {
  /deep/ .el-dialog .el-dialog__body {
    text-align: center !important;
  }

  /deep/ .el-dialog__footer {
    text-align: center !important;
  }
}

.email {
  /deep/ .el-form-item__content {
    display: flex;
  }
}
</style>
